import { api } from "common/api/api";

const getProvisionalUser = async (email) => {
  const path = "/users/provisional-user";
  const res = await api.get(path, { params: { email } });
  if (res.status !== 200) {
    throw new Error(res);
  }
  // NOTE: 該当する仮登録ユーザーが居ない場合、APIは null を返す。
  return res.data || null;
};

export { getProvisionalUser };
